import React from 'react';
import Stag from '../../atoms/Icon/Stag';
import Tux from '../../atoms/Icon/Tux';
import Record from '../../atoms/Icon/Record';

export default () => {
  return (
    <div className="Info">
      <h3> Attribution </h3>
      <div>
        <div>
          <small><Stag height={"18px"} width={"18px"} fill="#FFF" /> Antlers by Nick Bluth from the Noun Project</small>
        </div>
        <div>
          <small><Tux height={"18px"} width={"18px"} fill="#FFF" /> Tuxedo by Matthew R. Miller from the Noun Project</small>
        </div>
        <div>
          <small><Record height={"18px"} width={"18px"} fill="#FFF" /> Record by Dmitry Kovalev from the Noun Project</small>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/component/pages/Info/index.js